import angular from "angular";
import Cookies from 'cookies-js';
import cookiesService from "./cookies.service";

class CookiesConsent {
    constructor(CONFIG, cookiesService) {
        this.CONFIG = CONFIG;
        this.cookiesService = cookiesService;
    }

    validateAndSetCookies(cookiesBox) {
        let acceptedCookies = Cookies.get('CookieConsent');
        if (cookiesBox && acceptedCookies === undefined) {
            let closeButton = cookiesBox.querySelector('.js-close');
            cookiesBox.classList.remove('is-collapsed');

            closeButton.addEventListener('click', e => {
                e.preventDefault();
                cookiesBox.classList.add('is-collapsed');
                this.setCookie('{"performance":true,"targeting":true }');
            });
        }
    }

    setCookie(value) {
        Cookies.set('CookieConsent', value, {
            expires: 365 * 24 * 60 * 60,
            domain: this.CONFIG.cookiesGlobalDomain
        });
    }
    checkCookieConsent(){
        const userCookieConsent = Cookies.get('CookieConsent');
        if(!userCookieConsent){
            return;
        }

        const cookies = document.cookie.split(';');
        const objectUserCookieConsent = JSON.parse(userCookieConsent);
        cookies.forEach(cookie => {
            const name = (cookie.split('=')[0]).trim();
            if (name === 'CookieConsent') {
                return;
            }
            if(!this.cookiesService.isValidCookie(name, objectUserCookieConsent)){
                this.cookiesService.deleteCookie(name);
            }
        });
    }
}

const module = angular.module('st.services.cookiesConsent', [
    cookiesService
])
    .service('cookiesConsent', CookiesConsent)
    .name;

export default module;


// WEBPACK FOOTER //
// ./client/app/services/cookiesConsent.service.js